export default __webpack_public_path__ + "static/media/aryan.5bb3e23d.jpeg";